'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';

const CheckPriceButton = ({ fullwidth = true }) => {
  const t = useTranslations();
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  return (
    <CatButton
      variant="contrast"
      size="sm"
      fullWidth={fullwidth}
      onClick={() => dealerLocatorDrawer.openDrawer()}
    >
      {t('CAT_CHECK_PRICE')}
    </CatButton>
  );
};
export default CheckPriceButton;
